export default __webpack_public_path__ + "resources/icons/d412-eaf5.png";